
export default class Base {
    _id = null;
    type = 'base';
    ref_id = null;
    name = "";
    edges = [];
    items = [];
    price = 0.00;
    originalPrice = 0.00;
    image = null;
    parent_ref = null;
    parent = null;
    observation = null;
    description = null;
    extra_ingredients = [];
    position = null;
    delete = false;
    new = false;
    show = true;
    
    addItems = (items) => {
        let toProcess = !Array.isArray(items) ? [items] : items;
        let me = this;
        toProcess.map((v) => {
            v.parent_ref = me;
            switch(v.type) {
                case 'edge':
                    v.position = v.position || v.position === 0 ? v.position : me.edges.length;
                    me.edges.push(v);
                    break;
                case 'extraingredient':
                    v.position = v.position || v.position === 0 ? v.position : me.extra_ingredients.length;
                    me.extra_ingredients.push(v);
                    break;
                default:
                    v.position = v.position || v.position === 0 ? v.position : me.items.length;
                    me.items.push(v);
                    break;
            }
        });
    }
  
    list = ($class) => {
        let tmpList = this.constructor.name == $class ? [this] : [], me = this;
        ['edges', 'extra_ingredients', 'items'].map((property) => {
            me[property].map((item) => {
                let childList = item.list($class) || [];
                tmpList.push(...childList)
            })
        })
        return tmpList;
    }
  
    getItemsByParam = (param, value) => {
        let list = this[param] == value ? [this] : [], me = this;
        ['edges', 'extra_ingredients', 'items'].map((property) => {
            return me[property].map((item) => {
                let childList = item.getItemsByParam(param, value);
                if(childList.length > 0)
                    list = list.concat(...childList);
            });
        });
        return list;
    }
  
    toJSON = () => {
        let me = this;
        delete me.parent_ref;
        return me;
    }
}